<template>
	<div class="container_head ">
		<div class="card">
			<van-field v-model="qhxz" is-link readonly label="区划选择" placeholder="请选择所在地区" @click="show0 = true" label-width="4.2em"   />
			<van-popup v-model="show0" round position="bottom" >
				<van-cascader v-model="cascaderValue0" title="请选择所在地区" :options="optionarea" @close="show0 = false"
					@finish="onFinish0" />
			</van-popup>

			<van-field v-model="xqdz" is-link readonly label="房屋地址" placeholder="请选择房屋所在地址" name="houses2"
				@click="show = true" :rules="[{ required: true, message: '必填' }]" label-width="4.2em"
				v-if="cascaderValue0!=''" />
			<van-popup v-model="show" round position="bottom" >
				<van-cascader v-model="cascaderValue"  :options="options" @close="show = false"
					@change="onChange" @finish="onFinish" :placeholder="'请选择'+currarr">
					<template #title>
						<span class="custom-title">区划房屋选择</span>
						<button class="xz" type="button" v-show="showxz" @click.stop="addhousetc" >新增</button>
					</template>
				</van-cascader>
			</van-popup>
			<div class="sfxz" v-show="xqdz"> 
				<span>身份选择：</span>
				<van-radio-group v-model="sfchecked" direction="horizontal">
					<van-radio name="1">业主</van-radio>
					<van-radio name="2">业主家属</van-radio>
					<van-radio name="3">租客</van-radio>
				</van-radio-group>
			</div>
			<van-overlay :show="showxzly" @click="closelouyu">
            <div class="bohui" @click.stop>
                <div class="bh-title">
                    <span>新增楼宇</span>
                    <img src="../../assets/close.png" alt="" class="close" @click="closelouyu">
                </div>
                <van-cell-group>
					<van-field required v-show="currtbidx<1" v-model="xzlist.buildingNo"  label="楼栋号" maxlength='20' placeholder="请输入楼栋号" input-align="right" ></van-field>
					<van-field required v-show="currtbidx<2" v-model="xzlist.unitName"  label="单元号" maxlength='20' placeholder="请输入单元号" input-align="right" ></van-field>
					<van-field required v-show="currtbidx<3" v-model="xzlist.floorNum"  label="楼层" maxlength='20' placeholder="请输入楼层" input-align="right" ></van-field>
					<van-field required v-show="currtbidx<4" v-model="xzlist.ucAddress"  label="房屋号" maxlength='20' placeholder="请输入房屋号" input-align="right" ></van-field>
				</van-cell-group>
                <button class="tj" @click='addhouse'>保存</button>
            </div>
        </van-overlay>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Form,
		Cascader,
	} from 'vant';
	Vue.use(Form);
	Vue.use(Cascader);
	import { Dialog } from 'vant';
	import {
		mapState,
		mapMutations
	} from "vuex";
import { stringify } from 'qs';
	export default {
		name: 'chooseHouse',
		props: {
			houseId: String,
		},
		
		data() {
			return {
				qhxz: '',
				xqdz:'',
				sfchecked:'',
				showxzly:false,
				show0: false,
				show: false,
				cascaderValue0: '',
				showxzly:false,//展示新增楼宇
				showxz:false,//是否展示新增楼宇的按钮
				currarr:'小区',
				currtbidx:'',//选择房屋时当前的联级
				currselected:[],//当前选择好的
				optionarea: [],
				cascaderValue: '',
				options: [],
				chooseIndex:[0,0,0,0,0],
				idmen:{},
				xzlist:{}
			};
		},
		computed: {
			...mapState(["identity"]),
		},
		mounted() {
			//第一步 区划选择
			this.$axios.get('/api/v2/wechat/select/region').then(res => {
				var newarray=[];
				res.map(obj=>{
					newarray.push({
						value:obj.id,
						pid:obj.pId,
						text:obj.text
					})
				})
				// 结构化树形数据
				this.optionarea = this.formatTreeData(newarray);
			})
		},
		methods: {
			...mapMutations(["changeIdentity"]),
			onFinish0({
				selectedOptions
			}) {
				this.show0 = false;
				this.qhxz =selectedOptions.map((option) => option.text).join('');
				// 第二步获取小区
				this.$axios.get('/api/v2/wechat/select/community',{
					params: {
						regionId:this.cascaderValue0,
						key:''
					}
				}).then(res=>{
					var objarray=[];
					res.map(obj=>{
						objarray.push({
							text:obj.text,
							value:obj.id,
							children:[]
						})
					})
					this.options=objarray;
				})
			},
			closelouyu(){
				this.showxzly = false
				this.show = true
			},
			addhousetc(){
				this.xzlist = {}
				this.showxzly = true
				this.show = false
			},
			addhouse(){
				var addarr = Object.values(this.xzlist)
				if(addarr.includes('')){
					this.$toast.fail('有必填项未填写！')
				}else{
					this.xqdz = ''
					for(var i = 0;i<this.currtbidx+1;i++){
						this.xqdz += (this.currselected[i].text+'-')
					}
					var arr = Object.values(this.xzlist)
					this.xqdz+=arr.join('-')
					this.showxzly = false
					this.$emit('chuanxz',this.xzlist,this.idmen,this.currtbidx,this.sfchecked)
				}
			},
			onChange({
				value,
				selectedOptions,
				tabIndex
			}) {
				console.log(value, selectedOptions, tabIndex)
				this.currtbidx = tabIndex
				this.currselected=selectedOptions
				this.currarr = ''
				if(tabIndex==0){
					// 第三步获取楼栋
					this.idmen = {}
					this.chooseIndex[tabIndex]=this.options.findIndex(obj=>obj.value==value)
					this.idmen.villageId = selectedOptions[0].value
					this.$axios.get('/api/v2/wechat/select/building',{
						params: {
							communityId:value,
							key:''
						}
					}).then(res=>{
						var objarray=[];
						res.map(obj=>{
							objarray.push({
								text:obj.text,
								value:obj.id,
								children:[]
							})
						})
						this.options[this.chooseIndex[0]].children=objarray;
						this.showxz = true
						this.currarr = '楼栋号'
					})
				}else if(tabIndex==1){
					this.idmen = {}
					this.chooseIndex[tabIndex]=this.options[this.chooseIndex[0]].children.findIndex(obj=>obj.value==value)
					this.idmen.villageId = selectedOptions[0].value
					this.idmen.buildingId = selectedOptions[1].value
					//单元选择
					this.$axios.get('/api/v2/wechat/select/bunit',{
						params: {
							buildingId:value,
						}
					}).then(res=>{
						var objarray=[];
						res.map(obj=>{
							objarray.push({
								text:obj.text+'单元',
								value:obj.id,
								children:[]
							})
						})
						this.options[this.chooseIndex[0]].children[this.chooseIndex[1]].children=objarray;
						this.currarr = '单元'
					})
					
				}else if(tabIndex==2){
					this.idmen = {}
					this.chooseIndex[tabIndex]=this.options[this.chooseIndex[0]].children[this.chooseIndex[1]].children.findIndex(obj=>obj.value==value)
					this.idmen.villageId = selectedOptions[0].value
					this.idmen.buildingId = selectedOptions[1].value
					this.idmen.bunitId = selectedOptions[2].value
					// 第四步获取楼层
					this.$axios.get('/api/v2/wechat/select/floor',{
						params: {
							bunitId:value,
						}
					}).then(res=>{
						var objarray=[];
						res.map(obj=>{
							objarray.push({
								text:obj.text+'楼',
								value:obj.id,
								children:[]
							})
						})
						this.options[this.chooseIndex[0]].children[this.chooseIndex[1]].children[this.chooseIndex[2]].children=objarray;
						this.currarr = '楼层'
					})
				}else if(tabIndex==3){
					this.idmen = {}
					this.chooseIndex[tabIndex]=this.options[this.chooseIndex[0]].children[this.chooseIndex[1]].children[this.chooseIndex[2]].children.findIndex(obj=>obj.value==value)
					this.idmen.villageId = selectedOptions[0].value
					this.idmen.buildingId = selectedOptions[1].value
					this.idmen.bunitId = selectedOptions[2].value
					this.idmen.floorId = selectedOptions[3].value
					// 第五步获取房号
					this.$axios.get('/api/v2/wechat/select/house',{
						params: {
							floorId:value,
						}
					}).then(res=>{
						var objarray=[];
						res.map(obj=>{
							objarray.push({
								text:obj.text+'室',
								value:obj.id,
							})
						})
						this.options[this.chooseIndex[0]].children[this.chooseIndex[1]].children[this.chooseIndex[2]].children[this.chooseIndex[3]].children=objarray;
						this.currarr = '房屋号'
					})
				}
			},
			onFinish({
				selectedOptions
			}) {
				this.show = false;
				this.xqdz = selectedOptions.map((option) => option.text).join('');
				this.idmen.villageId = selectedOptions[0].value
				this.idmen.buildingId = selectedOptions[1].value
				this.idmen.bunitId = selectedOptions[2].value
				this.idmen.floorId = selectedOptions[3].value
				this.idmen.houseId = selectedOptions[4].value

				this.$emit('chuanxz',this.xzlist,this.idmen,this.currtbidx,this.sfchecked)
			},
			formatTreeData(arr) {
				// 删除所有的children，以防止多次调用
				arr.forEach(item => {
					delete item.children;
				});
				// 构建map
				let map = {};
				arr.forEach(c => {
					map[c.value] = c;
				});
				let treeData = [];
				arr.forEach(c => {
					const mapItem = c.pid ? map[c.pid] : '';
					if (c.pid != "" && mapItem) {
						// mapItem 存在，说明当前数据不是顶层数据
						(mapItem.children || (mapItem.children = [])).push(c);
					} else {
						// mapItem 不存在，说明当前数据是顶层数据
						treeData.push(c);
					}
				});
				return treeData;
			},
		}
	};
</script>

<style lang="less" scoped>
	.mb10 {
		margin-bottom: 10px;
	}
	/deep/ .van-overlay{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.bohui{
		// height: 275px;
		width: 90%;
		background: #fff;
		display: flex;
		flex-direction: column;
		align-items: center;
		border-radius: 10px;
		.bh-title{
			height: 40px;
			background: #e8f1f9;
			width: 100%;
			padding: 0 10px;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			justify-content: space-between;
			font-size: 13px;
			border-top-left-radius: 10px;
			border-top-right-radius: 10px;
			.close{
				height: 20px;
			}
		}
		.bh-text{
			width: 90%;
			height: 55%;
			margin-top: 10px;
		}
		.tj{
			width: 80%;
			height: 40px;
			margin-top: 10px;
			color: #fff;
			background: #0089ff;
			border-radius: 10px;
			border: none;
			outline: none;
			margin-bottom: 10px;
		}
	}
	.sfxz{
		display: flex;
		align-items: center;
		justify-content: space-around;
		margin-top: 10px;
		font-size: 14px;
	}
	.xz{
		height: 20px;
		width: 60px;
		background: linear-gradient(90deg, #fcae37, #fe784b);
		border: none;
		border-radius: 5px;
		color: #fff;
		margin-left: 20px;
		font-size: 13px;
	}
	.flexcenter {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.card {
		margin: 15px 10px;
		background-color: #fff;
		border-radius: 10px;
		padding: 10px 0;
	}

	.title {
		color: #ffad0e;
		font-size: 18px;
		text-align: center;
		margin: 5px 0 10px;
		font-weight: bold;
	}

	.tip {
		color: #ffa5a5;
		font-size: 12px;
		padding: 0px 5px 0 25px;
	}

	/deep/.van-field--error .van-field__control::placeholder {
		color: #ccc;
	}
/deep/.van-popup	.van-cascader__options{
		height:304px!important ;
	}
</style>
